import {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';

export default function Footer() {
  const {pathname} = useLocation();
  const [building, setBuilding] = useState<string | null>(null);
  const [floor, setFloor] = useState<string | null>(null);

  useEffect(() => {
    setBuilding(localStorage.getItem('building'));
    setFloor(localStorage.getItem('floor'));
  }, []);

  // ✅ 특정 경로에서는 밝은 배경 + 어두운 글씨 스타일 적용
  const isLightMode = LIGHT_MODE_PATHS.includes(
    pathname.startsWith('/') ? pathname.slice(1) : pathname,
  );

  return (
    <div
      className={`fixed p-2 text-xs rounded ${
        isLightMode
          ? 'text-neutral-500 bottom-1 right-1'
          : 'text-white bottom-1 right-1'
      }`}>
      <p>
        {building || '-'} / {floor || '-'}
      </p>
    </div>
  );
}

// ✅ 배경이 흰색이라 Footer를 어둡게 보이도록 할 페이지 목록
const LIGHT_MODE_PATHS = ['check-chart', 'create-chart'];
